import { Button } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import defaultAvatar from 'assets/img/default-avatar.png'
import * as moment from 'moment'
import * as React from 'react'
import './style.scss'
export interface INativeProps {
  open: boolean
  onclose: () => void
  item: any
}

interface IProps extends INativeProps {}

interface IState {
  textMask: string
}

export class NewPatientModal extends React.Component<IProps, IState> {
  render() {
    const { item, open, onclose } = this.props

    if (!item) {
      return null
    }

    const date = Math.abs(
      moment(item.birth_date * 1000).diff(
        moment().format('YYYY'),
        'years',
        true
      )
    )

    return (
      <Dialog
        open={open}
        style={{ width: '100%', borderRadius: 15 }}
        aria-labelledby="simple-dialog-title"
        className="new-patient-modal-wrapper"
      >
        <div className="modal-top">
          <div className="modal-top-text">
            Yay!
            <br /> We got you a new patient!
          </div>
        </div>
        <div className="modal-content">
          <img
            className="modal-content-image"
            src={item.patient_avatar || defaultAvatar}
          />
          <div className="modal-content-name">
            {item.name ? item.name : null}
          </div>
          <div className="modal-content-age">Age: {date.toFixed(1)} years</div>

          <div className="modal-bottom">
            <div className="modal-content-assessment">GAINTLEAP ASSESSMENT</div>
            <div className="modal-content-adhd">
              Medical literature would support referral to a pediatric
              psychiatrist due to low inhibition scores
            </div>
          </div>
        </div>
        <div className="modal-button-wrapper">
          <Button
            className="black-btn modal-button"
            color="primary"
            onClick={() => onclose()}
          >
            {'Dismiss'}
          </Button>
        </div>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NewPatientModal/index.tsx